import type React from "react";
import { createContext, useContext } from "react";
import type { StudyGroupResponse } from "@/lib/humhub-api/types";

export type StudyGroupRouteContext = {
  studyGroupId: number | null;
  studyGroupInfo: StudyGroupResponse | null;
  isStudyGroupLoading: boolean;
  studyGroupError: string | null;
  refetchStudyGroup: () => void;
};

const StudyGroupRouteContext = createContext<
  StudyGroupRouteContext | undefined
>(undefined);

export const StudyGroupRouteProvider: React.FC<{
  value: StudyGroupRouteContext;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <StudyGroupRouteContext.Provider value={value}>
    {children}
  </StudyGroupRouteContext.Provider>
);

export const useStudyGroupRouteContext = () => {
  const context = useContext(StudyGroupRouteContext);
  if (!context) {
    throw new Error(
      "useStudyGroupRouteContext must be used within a StudyGroupRouteProvider",
    );
  }
  return context;
};

export const useOptionalStudyGroupRouteContext = () => {
  return useContext(StudyGroupRouteContext);
};
